<template>
  <div class="clearfix_" id="JuneOneTemplate">
    <div class="footer_61"><img src="http://img.source.9188cn.com/footer_61.png"></div>
    <div class="banner" id="banner"><img src="http://img.source.9188cn.com/JuneOneBanner.jpg"></div>
    <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='recommend_61'||item.parentName=='recommend_61_copy1'||item.parentName=='recommend_61_copy2'">
        <div v-if="item.content!==undefined&&item.content!==null&&item.content.length>0" class="recommend" id="recommend_61">
            <div>
                <div class="recommend_list clearfix_">
                    <div @click="goto(val)" v-for="(val,idx) in item.content" :key="idx" class="fl recommend_item"><img :src="val.pic"></div>
                </div>
            </div>
        </div>
    </div>
    <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='goods_1_61'||item.parentName=='goods_1_61_copy1'||item.parentName=='goods_1_61_copy2'">

        <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" class="goods_1" id="goods_1_61">
            <div class="goods_box">
                <div class="goods_1_item_title_bg">
                    <div class="goods_1_item_title">{{item.title}}</div>
                </div>
                <div class="goods_1_doll"></div>
                <div class="goods_1_list">
                    <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="goods_1_item clearfix_">
                        <div class="clearfix_ goods_1_item_box">
                            <div class="goods_1_item_img fl"><img :src="val.pic?val.pic:noImg"></div>
                            <div class="goods_1_item_txt fl">
                                <div class="goods_1_item_price"><span>RMB：</span><i>{{val.beforePrice}}</i><span></span><span>{{val.afterPrice}}</span></div>
                                <div class="goods_1_item_name1">{{val.name}}</div>
                                <div class="goods_1_item_name2">{{val.goodsSellPoint}}</div>
                                <div class="goods_1_item_btn">查看详情</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='goods_2_61'||item.parentName=='goods_2_61_copy1'||item.parentName=='goods_2_61_copy2'"> 
        <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" class="goods_2" id="goods_2_61">
            <div class="goods_2_doll"></div>
            <div class="goods_1_item_title_bg">
                <div class="goods_1_item_title">{{item.title}}</div>
            </div>
            <div class="goods_2_box">
                <div v-show="val!==undefined&&val!==null&&val.length>0" v-for="(val,idx) in item.goods" :key="idx">
                    <div class="goods_2_list_1">
                        <div class="goods_2_list_2 clearfix_">
                            <div @click="gotoGoodsDetail(value)" v-for="(value,i) in val" :key="i" class="goods_2_item fl">
                                <div class="goods_2_item_img"><img :src="value.pic?value.pic:noImg"></div>
                                <div class="goods_2_item_price"><span>RMB：</span><i>{{value.beforePrice}}</i><span></span><span>{{value.afterPrice}}</span></div>
                                <div class="goods_2_item_name1">{{value.name}}</div>
                                <div class="goods_2_item_name2">{{value.goodsSellPoint}}</div>
                                <div class="goods_2_item_btn">查看详情</div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    
</div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return {
      allData:[],
      noImg:require("@/assets/img/aa.png")
    }
  },
  mounted:function(){
    this.getProject()
  },
  methods:{
    gotoGoodsDetail:function(obj){
			var t_=this
			var href=t_.$router.resolve({name:'goodsdetails',query:{goodsId:obj.id,isSupplyChainGoods:2,supplyChainTenantId:obj.supplyChainTenantId}})
			window.open(href.href,'_blank')
    },
    goto:function(obj){
			var t_ = this
			if( obj.status==1 ){
                if(obj.atriceId=='')return
				var href=this.$router.resolve({
					name:'articleList',
					query:{
						id:obj.atriceId
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==2){
				var d = obj.categoryId
				var href=this.$router.resolve({
					name:'goodslist',
					query: {
						id: d
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==3){
				var d = obj.search
				var href=this.$router.resolve({
					name:'goodslist',
					query: {
						txt: d
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==5){
				window.open(obj.link)
			}else if(obj.status==6){
				var href=t_.$router.resolve({
					name:'goodsdetails',
					query:{
						goodsId:obj.goodsId,
						isSupplyChainGoods:2,
						supplyChainTenantId:obj.supplyChainTenantId
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==9){
				if(obj.module==1){
					var href=this.$router.resolve({name:'teamGoods'});
					window.open(href.href,'_blank')
				}else if(obj.module==3){
					var href=this.$router.resolve({name:'couponList'});
					window.open(href.href,'_blank')
				}else if(obj.module==5){
					var href=this.$router.resolve({name:'activityList'});
					window.open(href.href,'_blank')
				}else if(obj.module==6){
					var href=this.$router.resolve({name:'scoreChange'});
					window.open(href.href,'_blank')
				}
			}
    },
    getProject:function(){
      var t_=this
      let data = Qs.stringify({
        channel:2,
        id:this.$route.query.id,
        tamp:localStorage.tamp?localStorage.tamp:''
      });
      axios.post(`${ip}formWorkInterface/getProject`, data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
        t_.allData=res.data.results
        }else{
          //return this.$router.push({path: '/'})
        }
      })
    }
  }
}
</script>
<style scoped>
#JuneOneTemplate{
    background: #fac7d6 url("http://img.source.9188cn.com/JuneOneBg_11.png") repeat-y left 812px;
    background-size: 100%;
    position: relative;
    padding-bottom: 50px;
}
#JuneOneTemplate #banner img{
    width: 100%;
}
#banner{
    height: auto;
    margin-bottom: 0;
}
#JuneOneTemplate .recommend{
    width: 660px;
    height: 147px;
    border: 10px solid #ff6b95;
    border-radius: 20px;
    background: #fff;
    margin: 0 auto;
    padding: 19px 0;
    position: relative;
}
#JuneOneTemplate .recommend{
    margin-top: 20px;
}
/* #JuneOneTemplate .recommend:first-child{
    margin-top: 0;
} */
.recommend_list{
    margin: 0 auto;
    width: 586px;
}
.recommend_item{
    width: 182px;
    height: 146px;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 20px;
    cursor: pointer;
}
.recommend_item:last-child{
    margin-right: 0;
}
.recommend_item img{
    width: 182px;
    height: 146px;
}
.recommend_mask{
    width: 680px;
    height: 205px;
    background: rgba(0,0,0,.5);
    position: absolute;
    top: -10px;
    left: -10px;
    display: none;
}
.recommend_mask>div{
    height: 40px;
    background: #fff;
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 5px;
    border: 1px solid #fb0;
}
.recommend_mask>div p{
    width: 60px;
    height: 40px;
    text-align: center;
    color: #000;
    font-size: 12px;
    line-height: 40px;
    cursor: pointer;
}
.goods_1_item{
    width: 718px;
    height: 370px;
    background: #fff;
    border: 12px solid #ff6c94;
    border-radius: 50px;
    margin-bottom: 12px;
    cursor: pointer;
}
.goods_1_item:last-child{
    margin-bottom: 0;
}
.goods_1{
    width: 742px;
    margin: 0 auto;
    position: relative;
    margin-top: 150px;
}
.goods_1_item_title_bg{
    width: 322px;
    height: 105px;
    position: absolute;
    left: 50%;
    top: -75px;
    margin-left: -161px;
    background: url("http://img.source.9188cn.com/JuneOneGoods2Title.png ");
    background-size: 100%;
}
.goods_1_item_title{
    width: 290px;
    height: 67px;
    line-height: 67px;
    color: #fff;
    text-align: center;
    font-size: 44px;
    position: absolute;
    left: 15px;
    bottom: 9px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.goods_1_item_box{
    width: 640px;
    margin: 0 auto;
    margin-top: 57px;
}
.goods_1_item_img{
    height: 255px;
    width: 255px;
}
.goods_1_item_img img{
    height: 255px;
    width: 255px;
}
.goods_1_item_price{
    width: 280px;
    font-size: 36px;
    color: #ff6c94;
    margin-bottom: 15px;
    text-align: center;
}
.goods_1_item_price span{
    font-size: 20px;
}
.goods_1_item_name1{
    font-size: 32px;
    color: #ff6c94;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    width: 280px;
    margin-bottom: 15px;
    text-align: center;
}
.goods_1_item_name2{
    font-size: 26px;
    color: #ff6c94;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    width: 280px;
    height: 50px;
    border-bottom: 1px dashed #ff6c94;
    margin-bottom: 15px;
    text-align: center;
}
.goods_1_item_btn{
    width: 197px;
    height: 38px;
    color: #fff;
    background: #ff6c94;
    text-align: center;
    line-height: 37px;
    font-size: 22px;
    border-radius: 20px;
    margin: 0 auto;
}
.goods_1_item_txt{
    margin: 25px 0 0 75px;
}
.goods_1_doll{
    width: 200px;
    height: 205px;
    position: absolute;
    top: -169px;
    right: -63px;
    background: url("http://img.source.9188cn.com/JuneOneDoll1.png");
    background-size: 100%;
}

.goods_2{
    width: 742px;
    margin: 0 auto;
    position: relative;
    margin-top: 95px;
}
.goods_2_doll{
    width: 197px;
    height: 160px;
    background: url("http://img.source.9188cn.com/JuneOneDoll2.png");
    background-size: 100%;
    position: absolute;
    top: -145px;
    left: 0;
}
.goods_2_item_title{
    top: 0px;
    left: 0px;
    width: 320px;
}
.goods_2_list_1{
    width: 718px;
    border: 12px solid #ff6c94;
    background: #fff;
    border-radius: 50px;
    padding: 40px 0;
    margin-top: 12px;
}
.goods_2_list_2{
    padding: 0 40px;
}
.goods_2_item{
    width: 279px;
    padding-right: 40px;
    border-right: 1px solid #ff6c94;
}
.goods_2_item:nth-child(2n){
    border-right: 0;
    padding-right: 0;
    padding-left: 39px;
}
.goods_2_item_img{
    width: 279px;
    height: 279px;
    margin-bottom: 10px;
}
.goods_2_item_img img{
    width: 279px;
    height: 279px;
}

.goods_2_item_price{
    font-size: 36px;
    color: #ff6c94;
    text-align: center;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.goods_2_item_price span{
    font-size: 20px;
}
.goods_2_item_name1{
    font-size: 26px;
    color: #ff6c94;
    text-align: center;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.goods_2_item_name2{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size: 20px;
    color: #ff6c94;
    text-align: center;
    margin-bottom: 10px;
    border-bottom: 1px dashed #ff6c94;
    height: 36px;
}
.goods_2_item_btn{
    width: 176px;
    height: 36px;
    text-align: center;
    background: #ff6c94;
    line-height: 35px;
    color: #fff;
    font-size: 20px;
    margin: 0 auto;
    border-radius: 20px;
}
#JuneOneTemplate #recommend_61_copy1{
    margin-top: 20px;
}
#JuneOneTemplate #recommend_61_copy2{
    margin-top: 20px;
}
.footer_61{
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
}
.footer_61 img{
    width: 100%;
}







</style>



// WEBPACK FOOTER //
// src/components/JuneOneTemplate/JuneOneTemplate.vue